import Phaser from 'phaser'

const lines = [
  '  ..',
  '> Police scanner 1.0.3b..',
  '> Ready to scan..',
  '> Scanning license plates..',
  '> Detecting stolen cars..'
]

export default class ScanningConsole extends Phaser.GameObjects.Text {
  constructor (scene) {
    super(scene, 10, 710, lines[0], {
      color: 'white',
      fontSize: '15pt'
    })
    this.setOrigin(0, 1)
    this.setAlign('left')

    this.reset()

    this.setAlpha(0)

    this.scene.player.on('scanning', () => {
      this.play()
      this.scene.tweens.add({
        duration: 300,
        targets: this,
        alpha: 1
      })
    })
    this.scene.player.on('backing', () => {
      this.reset()
      this.scene.tweens.add({
        duration: 100,
        targets: this,
        alpha: 0
      })
    })

    const resize = () => {
      if (this.scene) {
        this.x = 10 - (this.scene.scale.width - 1280) / 2
        this.y = 710 + (this.scene.scale.height - 720)
      }
    }
    this.scene.scale.on('resize', resize)
    resize()
  }

  reset () {
    if (this.timer) {
      this.timer.remove()
    }
    this.setText(lines[0])
    this.index = 0
  }

  play () {
    this.timer = this.scene.time.addEvent({
      delay: 200,
      repeat: lines.length - 2,
      callback: () => {
        this.index++
        this.setText(this.text + '\n' + lines[this.index])
      }
    })
  }
}
